export default __webpack_public_path__ + "static/media/Acolyte's Boots of the Abyss.5575f26a.jpg";